import * as CoreUI from "@coreui/coreui-pro";

const initializeCoreUI = () => {
  document.querySelectorAll(".sidebar").forEach((element) => {
    CoreUI.Sidebar.getOrCreateInstance(element);
  });

  document.querySelectorAll('[data-coreui-toggle="tooltip"]').forEach((element) => {
    CoreUI.Tooltip.getOrCreateInstance(element);
  });

  document.querySelectorAll('[data-coreui-toggle="popover"]').forEach((element) => {
    CoreUI.Popover.getOrCreateInstance(element);
  });
};

document.addEventListener("turbolinks:load", initializeCoreUI);
